/**
 * ui/labels.js
 * Tiện ích trích xuất nhãn hiển thị người dùng từ DOM các chip-btn tùy biến, kèm bộ nhớ đệm (cache).
 */

const labelCache = new Map();

const GROUP_ALIASES = {
  hairStyle: 'hair',
  outfit: 'outfit',
  pants: 'pants',
  hat: 'hat',
  eyewear: 'eyewear',
  mask: 'mask',
  wings: 'wings',
  tail: 'tail',
  bodyAcc: 'body-acc',
  held: 'held'
};

function formatFallbackLabel(value) {
  if (!value) return 'Mặc định';
  return String(value)
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export function getOptionLabel(groupId, value) {
  if (value === undefined || value === null || value === '' || value === 'none' || value === 'default') {
    return 'Mặc định';
  }

  const strValue = String(value);
  const targetGroup = GROUP_ALIASES[groupId] || groupId;
  const cacheKey = `${targetGroup}:${strValue}`;

  if (labelCache.has(cacheKey)) {
    return labelCache.get(cacheKey);
  }

  try {
    if (typeof document !== 'undefined') {
      const groupEl = document.getElementById(`group-${targetGroup}`);
      if (groupEl) {
        const buttons = groupEl.querySelectorAll('.chip-btn');
        let btn = null;
        for (let i = 0; i < buttons.length; i++) {
          if (buttons[i].dataset && buttons[i].dataset.val === strValue) {
            btn = buttons[i];
            break;
          }
        }
        if (btn) {
          const titleEl = btn.querySelector('.card-title');
          let label = '';
          if (titleEl && titleEl.textContent.trim()) {
            label = titleEl.textContent.trim();
          } else {
            // Lấy textContent, loại bỏ ký tự ✓ hoặc khoảng trắng thừa
            label = btn.textContent.replace(/[✓✕\n\r]/g, '').trim();
          }
          if (label) {
            labelCache.set(cacheKey, label);
            return label;
          }
        }
      }
    }
  } catch {
    // getOptionLabel không bao giờ throw lỗi
  }

  const fallback = formatFallbackLabel(strValue);
  labelCache.set(cacheKey, fallback);
  return fallback;
}
